import { Link, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useAsync } from '../lib/useAsync';
import { useApp } from '../AppContext';
import { PageHeader, Avatar } from '../components/Layout';
import { Card, SectionTitle, StageBadge, Spinner, ErrorNote, Empty } from '../components/ui';
import { money, initials, fmtDate, firstName } from '../lib/format';
import { PIPELINE_ORDER } from '../lib/stages';

export default function Dashboard() {
  const { user } = useApp();
  const navigate = useNavigate();
  const { data, error, loading, reload } = useAsync(() => api.get('/dashboard'), []);

  return (
    <>
      <PageHeader
        title="5 River Roofing"
        sub={`Hi ${firstName(user?.name)}`}
        action={<Avatar />}
      />
      <div className="view">
        {loading ? <Spinner label="Loading dashboard" /> : null}
        {error ? <ErrorNote onRetry={reload}>{error}</ErrorNote> : null}
        {data ? (
          <>
            <div className="kpi-grid">
              <Card className="kpi"><span className="lab">Active</span><span className="kpi-val">{data.kpis.activeProjects}</span><span className="trend">projects</span></Card>
              <Card className="kpi"><span className="lab">New Leads</span><span className="kpi-val">{data.kpis.newLeads}</span><span className="trend">awaiting visit</span></Card>
              <Card className="kpi"><span className="lab">In Progress</span><span className="kpi-val">{data.kpis.inProgress}</span><span className="trend">on site</span></Card>
              <Card className="kpi"><span className="lab">Outstanding</span><span className="kpi-val">{money(data.kpis.outstandingBalance)}</span><span className="trend">to collect</span></Card>
            </div>

            <Link className="btn pri block" to="/lead/new">＋ New Lead</Link>

            <Card tight>
              <SectionTitle sub="Choose a stage to filter">Pipeline</SectionTitle>
              <div className="pipe-grid" style={{ marginTop: 'var(--s-3)' }}>
                {data.pipeline.filter(s => PIPELINE_ORDER.includes(s.key)).map(s => (
                  <button
                    key={s.key}
                    className={`pipe-chip ${s.count === 0 ? 'zero' : ''}`}
                    onClick={() => navigate(`/pipeline?stage=${s.key}`)}
                  >
                    <span className="lab">{s.label}</span>
                    <span className="pipe-count">{s.count}</span>
                    <span className="pipe-bar"><span className="fill" style={{ width: `${Math.min(100, s.count * 20)}%` }} /></span>
                  </button>
                ))}
              </div>
            </Card>

            <Card tight>
              <SectionTitle>Recent activity</SectionTitle>
              {data.recent.length ? data.recent.map(p => (
                <Link key={p.id} className="listrow" to={`/project/${p.id}`}>
                  <span className="ava" aria-hidden="true">{initials(p.customer?.name || '?')}</span>
                  <span className="nm">
                    {p.customer?.name || 'Unknown'}
                    <span className="sb" style={{ display: 'block', fontWeight: 400 }}>
                      {p.title} · {fmtDate(p.updatedAt)}
                    </span>
                  </span>
                  <StageBadge stage={p.stage} />
                </Link>
              )) : <Empty>Nothing yet.</Empty>}
            </Card>
          </>
        ) : null}
      </div>
    </>
  );
}
